import * as React from 'react'
import {ReferenceCategory} from '../domain/models';

interface SelectedOrDeselectedButtonProps {
    itemId: number
    selectedItemsIds: number[]
    buttonText:string
    onSelectFunction: (itemId: number) => void
    onDeSelectFunction: (itemId: number) => void
}

export const SelectedOrDeselectedButton = (props:SelectedOrDeselectedButtonProps) => {
    const {itemId,onSelectFunction,onDeSelectFunction,selectedItemsIds,buttonText} = props

    if(!selectedItemsIds.some(x => x === itemId)) {
        return <button onClick={() => {onSelectFunction(itemId)}} className='btn btn-default'>{buttonText}</button>
    }
    else{
        return <button onClick={() => {onDeSelectFunction(itemId)}} className='btn btn-danger'>{buttonText}</button>
    }
}

interface ReferencesFilterProps {
    showFilter: boolean
    years: number []
    referenceCategories: ReferenceCategory []

    selectedYears: number []
    selectedCategoriesIds: number[]

    onReferenceCategorySelectFn: ( itemId: number) => void
    onReferenceCategoryDeselectFn: ( itemId: number) => void

    onYearSelectFn: (yearId: number) => void
    onYearDeSelectFn: (yearId: number) => void

    onResetFilterFn: () => void
    onApplyFilterFn: () => void
}

export const ReferencesFilter = (props: ReferencesFilterProps) => {
    const {showFilter,referenceCategories,selectedCategoriesIds,selectedYears,years,onReferenceCategoryDeselectFn,onReferenceCategorySelectFn,onYearDeSelectFn,onYearSelectFn,onResetFilterFn} = props

    let clearFilterButton = null
    if (selectedYears.length !== 0 || selectedCategoriesIds.length !== 0) {
        clearFilterButton = <button onClick={onResetFilterFn} className='btn btn-danger'>Zrušit filtr</button>
    }

    if (showFilter) {
        return (
            <div className='panel panel-default'>

                <div className='panel-heading'>Filtr referencí</div>

                <div className='panel-body'>

                    <div className='row'>
                        <p>Filtrovat podle kategorie:</p>
                        <div className='btn-group'>
                            {referenceCategories.map(category =>
                                <SelectedOrDeselectedButton
                                    key={category.Id}
                                    itemId={category.Id}
                                    selectedItemsIds={selectedCategoriesIds}
                                    buttonText={category.Name}
                                    onDeSelectFunction={onReferenceCategoryDeselectFn}
                                    onSelectFunction={onReferenceCategorySelectFn}/> )}
                        </div>
                    </div>

                    <br />

                    <div className='row'>
                        <p>Filtrovat podle roku:</p>
                        <div className='btn-group'>
                            {years.map(year =>
                                <SelectedOrDeselectedButton
                                    key={year}
                                    itemId={year}
                                    selectedItemsIds={selectedYears}
                                    buttonText={year.toString()}
                                    onSelectFunction={()=>{onYearSelectFn(year)}}
                                    onDeSelectFunction={()=>{onYearDeSelectFn(year)}}/>
                            )}
                        </div>
                    </div>

                    <br />

                    <div className='row'>
                        <div className='btn-group'>
                            { clearFilterButton }
                            {/*<button onClick={props.onApplyFilterFn} className='btn btn-success'>Filtrovat</button>*/}
                        </div>
                    </div>

                </div>

            </div>
        )
    }
    else{
        return <div></div>
    }
}


/** WEBPACK FOOTER **
 ** C:/BIZJ/Code/Business/Flexxus/Flexxus.Web/Scripts/flexxus-references-app/src/components/ReferencesFilter.tsx
 **/